import React from 'react'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'
import styles from './styles.module.scss'
interface Props {
  Header: string
  Subheader: string
  articleIds: string[]
}
export function CollectionCategory({ Header, Subheader, articleIds }: Props) {
  if (articleIds.length <= 0) {
    return null
  }
  return (
    <div className={'ui vertical inverted segment ' + styles.category}>
      <div className='ui container'>
        <h3 className={styles.categoryHeader}>
          <div className={styles.title}>{Header}</div>
          <div className={styles.subHeader}>{Subheader}</div>
        </h3>

        <div className='ui vertical very fitted segment'>
          <ArticleTeasers
            articleIds={articleIds}
            numberOfCards={'three'}
            className='doubling'
            sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE}
          />
        </div>
      </div>
    </div>
  )
}
